import {ControlsSnapshot} from '../../dashboard-controls/controls-snapshot';
import {createDateRangeWithServiceProvidersAndSoldTosRequest} from '../utils/widget-helper';
import {TopSoldTosRequest} from '../../../../store/analytics/types/top-sold-tos-types';

export function buildRequest(snapshot: ControlsSnapshot): TopSoldTosRequest {
    return Object.assign(createDateRangeWithServiceProvidersAndSoldTosRequest(snapshot), {});
}
